import { useEffect } from "react";
import { getPhases } from "../services/api-server/phases";
import { usePhaseStore } from "../stores/phaseStore";
import { TPhaseData } from "../types/phase";

const getPhaseIdFromPath = (pathname: string): string | null => {
	const notPhasePath = ["operation-settings", "preview"];
	const match = pathname.match(/^\/projects\/([^/]+)\/([^/]+)\/([^/]+)/);
	const phaseId = match ? match[3] : null;
	if (phaseId === null || notPhasePath.includes(phaseId)) {
		return null;
	}
	return phaseId;
};

function useInitPhase(currentTenantKey: string | null) {
	const { phase, setPhase } = usePhaseStore();
	const phaseId = getPhaseIdFromPath(location.pathname);

	useEffect(() => {
		if (!currentTenantKey) return;
		if (!phaseId) {
			setPhase({} as TPhaseData);
			return;
		}
		if (!phase || phase._id !== phaseId) {
			getPhases(currentTenantKey, {
				_id: phaseId,
			}).then((phase: any) => {
				setPhase(phase[0]);
			});
		}
	}, [phaseId, currentTenantKey]);
}

export default useInitPhase;
